<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="客户管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item label="客户类型">
									<el-select v-model="searchForm.customer_type" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.customer_type_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="客户名称">
									<el-input v-model="searchForm.customer_name" placeholder="请填写客户名称" clearable></el-input>
								</el-form-item>
								<el-form-item label="客户简称">
									<el-input v-model="searchForm.customer_as" placeholder="请填写客户简称" clearable></el-input>
								</el-form-item>
								<el-form-item label="客户编码">
									<el-input v-model="searchForm.customer_code" placeholder="请填写客户编码" clearable></el-input>
								</el-form-item>
								<el-form-item label="商务">
									<el-cascader placeholder="请选择商务" style="width: 100%;" v-model="searchForm.business_docking_id"
										:options="options.contact_ids_options" :props="{ multiple: false, emitPath: false }"
										:show-all-levels="false" filterable clearable></el-cascader>
								</el-form-item>
								<el-form-item label="状态">
									<el-select v-model="searchForm.status" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.status_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="是否黑名单">
									<el-select v-model="searchForm.is_blacklist" placeholder="请选择" style="width: 100%;" clearable>
										<el-option v-for="item in options.is_blacklist_options" :key="item.value" :label="item.label"
											:value="item.value">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="doSearch">查询</el-button>
									<el-button type="primary" @click="reset">重置</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con">
						<div class="k-table-wrapper">
							<div class="k-table-toolbar"
								style="margin-top:0; position: relative; padding: 0; padding-bottom: 10px; height: 70px;">
								<div
									style="position: absolute;right: 20px; top: 0; height: 50px; display: flex; align-items: center; z-index: 2;"
									v-if="$parent.$parent.isAuthAction('admin/customers/customer/createcustomer') || $parent.$parent.isAuthAction('admin/customers/export/exportcustomerexcel')">
									<el-button style="margin-right: 20px;"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/createcustomer')" type="primary"
										size="mini" @click="addCustomerOpen">新增客户</el-button>
									<el-link type="primary" :disabled="isDownloading" icon="el-icon-download" @click="exportData"
										v-if="$parent.$parent.isAuthAction('admin/customers/export/exportcustomerexcel') && activeListType=='first'">{{ isDownloading ?
											'下载中...' : '下载' }}</el-link>
								</div>
								<el-tabs v-model="activeListType" @tab-click="handleListtype" style="width: 100%;">
									<el-tab-pane label="客户列表" name="first"></el-tab-pane>
									<el-tab-pane label="草稿箱" name="second"></el-tab-pane>
								</el-tabs>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" :key="tableKey" style="width: 100%" row-key="id" border stripe
									ref="table" highlight-current-row v-loading="loading" @sort-change="sortChange" :height="tableHeight">
									<el-table-column prop="customer_code" label="客户编码" v-if="activeListType == 'first'" min-width="200">
									</el-table-column>
									<el-table-column fixed prop="customer_name" label="客户名称" min-width="240">
										<template slot-scope="scope">
											<el-link v-if="activeListType == 'first'" type="primary"
												style="font-size: 12px; text-decoration: underline;" :underline="false"
												@click="detail(scope.row)" target="_blank">{{ scope.row.customer_name }}</el-link>
											<span v-else type="primary">{{ scope.row.customer_name }}</span>
										</template>
									</el-table-column>
									<el-table-column prop="customer_as" label="客户简称" min-width="150">
									</el-table-column>
									<el-table-column prop="customer_number" label="税号" min-width="200">
									</el-table-column>
									<el-table-column prop="customer_type" label="客户类型" min-width="150">
									</el-table-column>
									<el-table-column prop="isContact" label="客户合同" v-if="activeListType == 'first'" min-width="80">
									</el-table-column>
									<el-table-column prop="create_name" label="创建人" width="80">
									</el-table-column>
									<el-table-column prop="business_name" label="商务" width="80">
									</el-table-column>
									<el-table-column prop="is_blacklist" label="是否黑名单" v-if="activeListType == 'first'" width="100">
										<template slot-scope="scope">
											<el-switch @change="handleTableBlack(scope.row)" v-model="scope.row.is_blacklist"
												:active-value='1' :inactive-value='2'
												:disabled='scope.row.status != 1 && $parent.$parent.isAuthAction("admin/customers/customer/updatecustome")'>
											</el-switch>
										</template>
									</el-table-column>
									<el-table-column prop="create_time" label="创建时间" width="150">
									</el-table-column>
									<el-table-column prop="update_time" label="修改时间" width="150">
									</el-table-column>
									<el-table-column fixed="right" prop="status_txt" align="center" label="状态" v-if="activeListType == 'first'" width="80">
									</el-table-column>
									<el-table-column fixed="right" label="操作"
										v-if="$parent.$parent.isAuthAction('admin/customers/customer/editcustomer') || $parent.$parent.isAuthAction('admin/customers/customer/editcustomerdraft') || $parent.$parent.isAuthAction('admin/customers/customer/delcustomer') || $parent.$parent.isAuthAction('admin/customers/customer/delcustomerdraft') || $parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitcustomer') || $parent.$parent.isAuthAction('admin/customers/customer/addcontacts') || $parent.$parent.isAuthAction('admin/customers/customer/updatebusiness')"
										:width="activeListType == 'first' ? 160 : 120">
										<template slot-scope="scope">
											<el-button @click="handleTableEditOpen(scope.row)" type="text" :size="size"
												:disabled="!(scope.row.status != 2)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/editcustomer') || $parent.$parent.isAuthAction('admin/customers/customer/editcustomerdraft')">编辑</el-button>
											<el-button @click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger"
												:disabled="(!([1, 3].indexOf(scope.row.status) != -1) && activeListType == 'first')"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/delcustomer') || $parent.$parent.isAuthAction('admin/customers/customer/delcustomerdraft')">删除</el-button>
											<el-button @click="handleTableFlow(scope.row)" type="text" :size="size"
												:disabled="!([1, 3].indexOf(scope.row.status) != -1)"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/confirmsubmitcustomer') && activeListType == 'first'">提交审批</el-button>
												<el-button @click="handleContactsOpen('other',scope.row.id,scope.row.business_docking_id)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/updatebusiness') && activeListType == 'first'">变更商务</el-button>	
											<el-button @click="handleContactsOpen('contact',scope.row.id,scope.row.abutment_ids)" type="text" :size="size"
												v-if="$parent.$parent.isAuthAction('admin/customers/customer/addcontacts') && activeListType == 'first'">添加对接人</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[20, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--添加客户-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" direction="rtl" v-loading="loading"
			:close-on-press-escape='false' :wrapperClosable='false' size="70%">
			<div class="drawer-header">
				<div class="header-title">
					<span v-if="formType == 'add'">新增客户</span>
					<span v-else>编辑客户</span>
					<i class="el-icon-close k-drawer-close" @click="closeForm"></i>
				</div>
			</div>
			<div class="drawer-content">
				<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="140px">
					<el-steps :active="supplier_active" finish-status="success" align-center style="margin-top: 20px;">
						<el-step title="基本信息"></el-step>
						<el-step title="联系人与对接人"></el-step>
						<el-step title="风险信息"></el-step>
						<el-step title="开票信息"></el-step>
						<el-step title="完成"></el-step>
					</el-steps>
					<div class="addBox" v-show="supplier_active == 0">
						<el-form-item label="客户类型" prop="info.customer_type" key="customer_type">
							<el-select v-model="addForm.info.customer_type" placeholder="请选择客户类型" style="width: 100%;">
								<el-option v-for="item in options.customer_type_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="客户名称" prop="info.customer_name" key="info.customer_name">
							<el-input v-model="addForm.info.customer_name" placeholder="请填写客户名称" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="客户简称" prop="info.customer_as" key="info.customer_as">
							<el-input v-model="addForm.info.customer_as" placeholder="请填写客户简称" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="税号" prop="info.customer_number" key="info.customer_number">
							<el-input v-model="addForm.info.customer_number" placeholder="请输入税号" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="客户行业" key="customer_industry">
							<el-input v-model="addForm.info.customer_industry" placeholder="请输入客户行业" clearable></el-input>
						</el-form-item>
						<el-form-item label="法定代表人" key="legal_representative">
							<el-input v-model="addForm.info.legal_representative" placeholder="请输入法定代表人" clearable></el-input>
						</el-form-item>
						<el-form-item label="注册资本" key="registered_capital" prop="info.registered_capital">
							<el-input placeholder="请输入注册资本" v-model="addForm.info.registered_capital" style="width: 300px;">
								<template slot="append">万元</template>
							</el-input>
						</el-form-item>
						<el-form-item label="成立日期" key="date_of_establishment">
							<el-date-picker v-model="addForm.info.date_of_establishment" type="date" format="yyyy-MM-dd"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="营业执照到期时间" prop="info.end_type" key="business_license_end_type">
							<el-radio-group v-model="addForm.info.end_type">
								<el-radio :label="1">长期</el-radio>
								<el-radio :label="2">指定日期</el-radio>
							</el-radio-group>
							<div style="margin-top:5px" v-if="addForm.info.end_type == 2">
								<el-date-picker v-model="addForm.info.business_license_end" type="date" format="yyyy-MM-dd"
									value-format="yyyy-MM-dd" placeholder="选择日期">
								</el-date-picker>
							</div>
						</el-form-item>
						<el-form-item label="经营范围" key="business_scope">
							<el-input type="textarea" v-model="addForm.info.business_scope" placeholder="请输入经营范围" clearable
								maxlength="100" show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="营业执照" prop="info.business_license_pic" key="business_license_pic">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.info.business_license_pic"
								:on-remove="(file) => handleRemoveUpload(file, 'info', 'business_license_pic', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'info', 'business_license_pic', true)" :on-preview="viewImg">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="商务所属部门" prop="info.medium_department_id">
							<el-cascader @change="handleChangeDepartment($event, 'clear')" placeholder="请选择商务所属部门" style="width: 100%;"
								v-model="addForm.info.medium_department_id" :options="options.usertree_options"
								:props="{ multiple: false, emitPath: false, value: 'id', label: 'department_name', checkStrictly: 'true' }"
								:show-all-levels="false" filterable clearable></el-cascader>
						</el-form-item>
						<el-form-item label="商务" prop="info.business_docking_id">
							<el-select v-model="addForm.info.business_docking_id" placeholder="请选择商务">
								<el-option v-for="item in options.business_docking_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div class="addBox" v-show="supplier_active == 1">
						<el-form-item label="联系人姓名" prop="contacts.name" key="name">
							<el-input v-model="addForm.contacts.name" placeholder="请填写联系人姓名" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="联系人职位" prop="contacts.position" key="position">
							<el-input v-model="addForm.contacts.position" placeholder="请填写联系人职位" clearable maxlength="20"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="联系人手机号" prop="contacts.link_phone" key="link_phone">
							<el-input v-model="addForm.contacts.link_phone" placeholder="请填写联系人手机号" clearable></el-input>
						</el-form-item>
						<el-form-item label="联系人邮箱" prop="contacts.email" key="email">
							<el-input v-model="addForm.contacts.email" placeholder="请填写联系人邮箱" clearable></el-input>
						</el-form-item>
						<el-form-item label="联系人微信" key="wechat">
							<el-input v-model="addForm.contacts.wechat" placeholder="请填写联系人微信" clearable maxlength="30"
								show-word-limit></el-input>
						</el-form-item>
						<el-form-item label="对接人" prop="contacts.contact_ids_txt">
							<!-- v-if="activeListType == 'second' || formType == 'add'"-->
							<el-input v-model="addForm.contacts.contact_ids_txt" placeholder="请选择对接人" class="kDisabledInput"
								@focus="openDjr()"></el-input>
							<!-- <el-input v-model="addForm.contacts.contact_ids_txt" placeholder="请选择对接人" class="kDisabledInput" disabled v-else></el-input> -->
						</el-form-item>
					</div>
					<div class="addBox" v-show="supplier_active == 2">
						<el-form-item label="是否预付款" prop="risk.is_advance" key="is_advance">
							<el-radio-group v-model="addForm.risk.is_advance" @input="changeAdvance">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="2">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="预付款比例" key="advance_payment" prop="risk.advance_payment"
							v-if="addForm.risk.is_advance == 1">
							<el-input placeholder="请输入预付款比例" v-model="addForm.risk.advance_payment" style="width: 300px;">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item label="账期" key="period" prop="risk.period">
							<el-input placeholder="请输入账期" v-model="addForm.risk.period" style="width: 300px;">
								<template slot="append">天</template>
							</el-input>
						</el-form-item>
						<el-form-item label="授信额度" key="credit_line" prop="risk.credit_line">
							<el-input placeholder="请输入授信额度" v-model="addForm.risk.credit_line" style="width: 300px;">
								<template slot="append">万元</template>
							</el-input>
						</el-form-item>
						<el-form-item label="平均利润率" key="average_profit_margin" prop="risk.average_profit_margin">
							<el-input placeholder="请输入平均利润率" v-model="addForm.risk.average_profit_margin" style="width: 300px;">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item label="最低利润率" key="minimum_profit_margin" prop="minimum_profit_margin">
							<el-input placeholder="请输入最低利润率" v-model="addForm.risk.minimum_profit_margin" style="width: 300px;">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
					</div>
					<div class="addBox" v-show="supplier_active == 3">
						<el-form-item label="公司" required>
							<el-input v-model="addForm.info.customer_name" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="税号" required>
							<el-input v-model="addForm.info.customer_number" :disabled="true"></el-input>
						</el-form-item>
						<el-form-item label="单位地址" prop="invoice.address" key="address">
							<el-input v-model="addForm.invoice.address" placeholder="请填写单位地址" clearable maxlength="70" show-word-limit
								:disabled="formStatus == 4"></el-input>
						</el-form-item>
						<el-form-item label="电话号码" prop="invoice.phone" key="phone">
							<el-input v-model="addForm.invoice.phone" placeholder="请填写电话号码" clearable
								:disabled="formStatus == 4"></el-input>
						</el-form-item>
						<el-form-item label="开户行及支行" prop="invoice.bank_branch" key="bank_branch">
							<el-col :span="11">
								<el-select v-model="addForm.invoice.bank_of_deposit" :disabled="formStatus == 4"
									@change="requestZh(addForm.invoice.bank_of_deposit, 'clear')" filterable placeholder="请选择开户行" clearable
									style="width: 100%;">
									<el-option v-for="item in options.khh_options" :key="item.id" :label="item.bank_name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col class="line" style="width:20px; text-align: center;">-</el-col>
							<el-col :span="12">
								<el-select style="width: 100%;" v-model="addForm.invoice.bank_branch" filterable allow-create
									:disabled="formStatus == 4" default-first-option placeholder="请选择支行">
									<el-option v-for="item in options.zh_options" :key="item.id" :label="item.bank_name" :value="item.id">
									</el-option>
								</el-select>
								<!-- <el-select v-model="addForm.invoice.bank_branch" placeholder="请选择支行" filterable clearable style="width: 100%;">
							  <el-option
								v-for="item in options.zh_options"
								:key="item.id"
								:label="item.bank_name"
								:value="item.id">
							  </el-option>
						  </el-select> -->
							</el-col>
						</el-form-item>
						<el-form-item label="银行卡号" prop="invoice.bank_card" key="bank_card">
							<el-input v-model="addForm.invoice.bank_card" placeholder="请填写银行卡号" clearable maxlength="30"
								show-word-limit :disabled="formStatus == 4"></el-input>
						</el-form-item>
						<el-form-item label="发票类型" prop="invoice.invoice_type" key="invoice_type">
							<el-radio-group v-model="addForm.invoice.invoice_type" :disabled="formStatus == 4">
								<el-radio :label="1">普票</el-radio>
								<el-radio :label="2">专票</el-radio>
								<el-radio :label="3">形式发票</el-radio>
							</el-radio-group>
						</el-form-item>
						<el-form-item label="发票率" prop="invoice.invoice_rate" key="invoice.invoice_rate">
							<el-input v-model="addForm.invoice.invoice_rate" placeholder="请填写发票率" clearable style="width: 300px;"
								:disabled="formStatus == 4">
								<template slot="append">%</template>
							</el-input>
						</el-form-item>
						<el-form-item label="回款账户" prop="invoice.refund_account" key="refund_account">
							<el-select v-model="addForm.invoice.refund_account" placeholder="请选择回款账户" style="width: 100%;"
								:disabled="formStatus == 4">
								<el-option v-for="item in options.refund_account_options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="开户许可证" prop="invoice.invoice_prove" key="invoice_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.invoice_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'invoice_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'invoice', 'invoice_prove', true)" :on-preview="viewImg"
								:disabled="formStatus == 4">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="发票证明" prop="invoice.fp_attachment" key="fp_attachment">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.fp_attachment"
								:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'fp_attachment', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'invoice', 'fp_attachment', true)" :on-preview="viewImg"
								:disabled="formStatus == 4">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<el-form-item label="一般纳税人证明" prop="invoice.taxpayer_prove" key="taxpayer_prove">
							<el-upload action accept=".jpg,.jpeg,.png,.pdf" :file-list="addForm.invoice.taxpayer_prove"
								:on-remove="(file) => handleRemoveUpload(file, 'invoice', 'taxpayer_prove', true)" :auto-upload="false"
								:on-change="(file) => changeRequired(file, 'invoice', 'taxpayer_prove', true)" :on-preview="viewImg"
								:disabled="formStatus == 4">
								<el-button slot="trigger" size="mini">选取文件</el-button>
								<span style="margin-left: 10px; cursor: pointer;">
									<el-tooltip class="item" effect="dark" content="支持jpg/png/jpeg/pdf格式" placement="bottom-start">
										<i class="el-icon-warning-outline" style="padding:0 6px; color: #cccccc !important;"></i>
									</el-tooltip>
								</span>
							</el-upload>
						</el-form-item>
						<div style="margin-top: 20px; color: #F56C6C; text-align: center;" v-if="formStatus == 4">本页信息不可修改</div>
					</div>
					<div class="addBox" v-show="supplier_active == 4">
						<div class="supplierEnd">
							<i class="el-icon-success" style="color: #67C23A; font-size: 60px;"></i>
							<p v-if="formType == 'add'" class="tips">新建客户已提交成功！</p>
							<p v-if="formType == 'edit'" class="tips">客户信息已修改成功！{{ other_tip }}</p>
							<div class="btn">
								<!-- <el-button type="primary" size="mini">再次新增</el-button> -->
								<el-button size="mini" @click="closeForm()">确定</el-button>
							</div>
						</div>
					</div>
				</el-form>
			</div>
			<div class="drawer-footer" v-show="supplier_active != 4">
				<el-button type="primary" @click="next()" :size='size' v-show="supplier_active < 3">下一步</el-button>
				<el-button @click="prev()" :size='size' v-show="supplier_active > 0">上一步</el-button>
				<el-button type="primary" @click="addCtsupplier" :size='size' v-show="supplier_active == 3">提交</el-button>
				<el-button type="primary" @click="saveTemplate()" plain
					v-if="(formType == 'add' && supplier_active < 3) || activeListType == 'second' && supplier_active < 3"
					:size='size'>保存</el-button>
				<el-button :size='size' @click="closeForm">取消</el-button>
			</div>
		</el-drawer>
		<el-dialog :visible.sync="dialogVisibleImg">
			<img width="100%" :src="dialogImageUrl" alt="">
		</el-dialog>
		<el-dialog title="请选择对接人" :close-on-click-modal="false" :visible.sync="dialogVisibleContactids"
			@opened="openedIsshow()" width="50%">
			<!-- :destroy-on-close="true" -->
			<treeTransfer v-if="isshow" :item="ContactidsData" @field-event="fieldEvent($event)">
			</treeTransfer>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisibleContactids = false" :size="size">取 消</el-button>
				<el-button type="primary" @click="confirmContactids()" :size="size">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog v-if="infoDisabled" :title="multipleType=='contact'?'新增对接人':'变更商务'" :close-on-click-modal="false" :visible.sync="infoDisabled" width="30%"
			v-loading="loading">
			<el-form ref="oneInfoData" :model="oneInfoData" :size="size" label-width="80px">
				<el-form-item :label="multipleType=='contact'?'对接人':'商务'">
					<el-select style="max-width:100%;" v-model="oneInfoData.uid" filterable :multiple="multiple" placeholder="请选择人员">
						<el-option
							v-for="item in options.contact_options"
							:key="item.value"
							:label="item.label"
							:value="item.value">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" @click="infoDisabled = false">取 消</el-button>
				<el-button type="primary" :size="size" @click="updateCustomerInfo()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import treeTransfer from '../unit/Treetransfer';
export default {
	components: {
		treeTransfer
	},
	data () {
		return {
			other_tip: '',
			multiple:true,
			multipleType:'contact',
			isshow: false,
			infoDisabled: false,
			isDownloading: false,
			loading: false,
			dialogImageUrl: '',
			dialogVisibleImg: false,
			addFormVisiable: false,
			dialogVisibleContactids: false,
			ContactidsData: {},
			activeName: 'first',
			activeListType: 'first',
			size: 'mini',
			oneInfoData:{
				id:'',
				uid:''
			},
			options: {
				contact_options:[],
				customer_type_options: [
					{
						value: 1,
						label: '战略客户(直客)'
					}, {
						value: 2,
						label: '行业巨头(直客)'
					}, {
						value: 3,
						label: '区域巨头(直客)'
					}, {
						value: 4,
						label: '行业新贵(直客)'
					}, {
						value: 5,
						label: '普通(直客)'
					}, {
						value: 6,
						label: '关联公司(代理)'
					}, {
						value: 7,
						label: '盟友公司(代理)'
					}, {
						value: 8,
						label: '普通(代理)'
					}
				],
				is_blacklist_options: [
					{
						value: 1,
						label: '是'
					}, {
						value: 2,
						label: '否'
					}
				],
				status_options: [
					{
						value: 1,
						label: '待提交'
					}, {
						value: 2,
						label: '待审核'
					}, {
						value: 3,
						label: '被驳回'
					}, {
						value: 4,
						label: '正常'
					}
				],
				business_docking_options: [],//商务
				contact_ids_options: [],//对接人
				khh_options: [],//开户行-开票信息
				zh_options: [],//支行-开票信息
				refund_account_options: [],//汇款账户
				usertree_options: [],//所有用户
			},
			supplier_active: 0,
			searchForm: {
				customer_type: '',
				customer_name: '',
				customer_as: '',
				customer_code: '',
				business_docking_id: '',
				status: '',
				is_blacklist: ''
			},
			resetSearch: {
				customer_type: '',
				customer_name: '',
				customer_as: '',
				customer_code: '',
				business_docking_id: '',
				status: '',
				is_blacklist: ''
			},
			formType: 'add',
			formStatus: '',
			addForm: {
				info: {
					customer_type: '',
					customer_name: '',
					customer_as: '',
					customer_number: '',
					customer_industry: '',
					legal_representative: '',
					registered_capital: '',
					date_of_establishment: '',
					end_type: 1,
					business_license_end: '',
					business_scope: '',
					business_license_pic: [],
					medium_department_id: '',
					business_docking_id: ''
				},
				contacts: {
					name: '',
					link_phone: '',
					email: '',
					position: '',
					checkedContactids: [],
					contact_ids: [],
					contact_ids_txt: '',
					wechat: ''
				},
				risk: {
					is_advance: 1,
					advance_payment: '',
					period: '',
					credit_line: '0',
					average_profit_margin: '0',
					minimum_profit_margin: '0'
				},
				invoice: {
					address: '',
					phone: '',
					bank_of_deposit: '',
					bank_branch: '',
					bank_card: '',
					invoice_type: '',
					invoice_rate: '',
					refund_account: '',
					invoice_prove: [],
					fp_attachment: [],
					taxpayer_prove: []
				}
			},
			rules: {
				addForm: {
					info: {
						'customer_type': [
							{ required: true, message: '请选择客户类型', trigger: ['change'] }
						],
						'customer_name': [
							{ required: true, message: '请填写客户名称', trigger: ['change', 'blur'] },
							{ max: 20, message: '请填写正确的客户名称，长度不超过 20', trigger: ['change', 'blur'] }
						],
						'customer_as': [
							{ required: true, max: 20, message: '请填写正确的客户简称，长度不超过 20', trigger: ['change', 'blur'] }
						],
						'customer_number': [
							{ required: true, message: '请填写税号', trigger: ['change', 'blur'] },
							{
								pattern: /^[A-Za-z0-9]+$/,
								message: '只能包含字母和数字',
								trigger: ['change', 'blur'],
							}
						],
						'registered_capital': [
							{
								pattern: /(^[1-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
								message: '金额必须为非负数，且最多包含两位小数',
								trigger: 'blur'
							}
						],
						'end_type': [
							{ required: true, message: '请选择营业执照到期时间', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									if ((this.addForm.info.end_type == 2 && !this.addForm.info.business_license_end) || !value) {
										callback(new Error('请填写营业执照到期时间'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'medium_department_id': [
							{ required: true, message: '请选择商务所属部门', trigger: ['change', 'blur'] }
						],
						'business_docking_id': [
							{ required: true, message: '请选择商务', trigger: ['change', 'blur'] }
						],
						'business_license_pic': [
							{
								required: true, validator: (rule, value, callback) => {
									if (this.addForm.info.business_license_pic.length < 1) {
										callback(new Error('请上传营业执照'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						]
					},
					contacts: {
						'name': [
							{ required: true, message: '请填写联系人姓名', trigger: ['change'] }
						],
						'link_phone': [
							{ required: true, message: '请填写联系人手机号', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									const reg = /^1[3-9]\d{9}$/; // 中国大陆手机号码正则表达式
									if (!reg.test(value) && value) {
										callback(new Error('请输入有效的电话号码'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'email': [
							{ required: true, message: '请填写联系人邮箱', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									const reg = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})*$/; // 基本的邮箱地址正则表达式
									if (!reg.test(value)) {
										callback(new Error('请输入有效的电子邮件地址'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'position': [
							{ required: true, message: '请填写联系人职位', trigger: ['change', 'blur'] }
						],
						'contact_ids_txt': [
							{ required: true, message: '请选择对接人', trigger: ['change', 'blur'] }
						]
					},
					risk: {
						'is_advance': [
							{ required: true, message: '请选择是否预付款', trigger: ['change'] }
						],
						'advance_payment': [
							{ required: true, message: '请填写预付款比例', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									if (value > 100) {
										callback(new Error('预付款比例不能大于100%'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'period': [
							{ required: true, message: '请填写账期(天)', trigger: ['change'] },
							{ pattern: /^[0-9]\d*$/, message: '账期必须为数字', trigger: 'blur' }
						],
						'credit_line': [
							{
								pattern: /(^[0-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
								message: '授信额度必须为非负数，且最多包含两位小数',
								trigger: 'blur'
							}
						],
						'average_profit_margin': [
							{
								pattern: /(^[0-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
								message: '平均利润率必须为非负数，且最多包含两位小数',
								trigger: 'blur'
							}
						],
						'minimum_profit_margin': [
							{
								pattern: /(^[0-9]\d*(\.\d{1,2})?$)|(^0(\.\d{1,2})?$)/,
								message: '最低利润率必须为非负数，且最多包含两位小数',
								trigger: 'blur'
							}
						],
					},
					invoice: {
						'address': [
							{ required: true, message: '请填写单位地址', trigger: ['change'] }
						],
						'phone': [
							{ required: true, message: '请填写电话号码', trigger: ['change', 'blur'] },
							{
								validator: (rule, value, callback) => {
									const phoneReg = /^1[3-9]\d{9}$|^\d{3,4}-\d{7,8}$/; // 座机号码正则可能需要进一步精确
									if (!phoneReg.test(value)) {
										callback(new Error('请输入正确的手机号或座机号'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bank_branch': [
							{
								required: true, validator: (rule, value, callback) => {
									if (!this.addForm.invoice.bank_of_deposit) {
										callback(new Error('请选择开户行'));
									} else if (!this.addForm.invoice.bank_branch) {
										callback(new Error('请选择支行'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'bank_card': [
							{
								required: true, validator: (rule, value, callback) => {
									const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
									if (!value) {
										callback(new Error('请填写银行卡号'));
									} else {
										if (!regex.test(value)) {
											callback(new Error('请填写正确的银行卡号'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'invoice_type': [
							{ required: true, message: '请选择发票类型', trigger: ['change', 'blur'] }
						],
						'invoice_rate': [
							//{required: true, message: '请填写发票率', trigger: ['change', 'blur']},
							{
								required: true, validator: (rule, value, callback) => {
									const regex = /^\d+(\.\d+)?$/; // 匹配整数或浮点数
									if (!value) {
										callback(new Error('请填写发票率'));
									} else {
										if (!regex.test(value)) {
											callback(new Error('请填写正确的发票率'));
										} else {
											callback();
										}
									}
								}, trigger: ['change', 'blur']
							}
						],
						'refund_account': [
							{ required: true, message: '请选择回款账户', trigger: ['change', 'blur'] }
						],
						'invoice_prove':[
							{
								required: true, validator: (rule, value, callback) => {
									if (this.addForm.invoice.invoice_prove.length < 1) {
										callback(new Error('请上传开户许可证'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'fp_attachment': [
							{
								required: true, validator: (rule, value, callback) => {
									if (this.addForm.invoice.fp_attachment.length < 1) {
										callback(new Error('请上传发票证明'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						],
						'taxpayer_prove': [
							{
								required: true, validator: (rule, value, callback) => {
									if (this.addForm.invoice.taxpayer_prove.length < 1) {
										callback(new Error('请上传一般纳税人证明'));
									} else {
										callback();
									}
								}, trigger: ['change', 'blur']
							}
						]
					}
				}
			},
			tableData: {
				total: 0,
				pagesize: 20,
				page: 1,
				data: []
			},
			tableKey: 0
		}
	},
	computed: {
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	watch: {
	},
	mounted: function () {
		this.loading = true
		//this.handleSearch(this.searchForm);
		this.getContactIds()//获取商务获取对接人
		this.requestKhh()//获取开户行
		this.getRemittanceBanck()//获取回款账户
		this.getUserTree()
	},
	created () {
	},
	methods: {
		updateCustomerInfo(){
			if (this.multipleType == 'contact'){
				this.$api.post('/admin/customers/customer/addcontacts', this.oneInfoData).then(res => {
							if (res.code == 0) {
								this.infoDisabled = false
								this.$message.success('信息变更成功');
								this.doSearch()
							}else{
								this.$message.error(res.msg);
							}
						})
			}else{
				this.$api.post('/admin/customers/customer/updatebusiness', this.oneInfoData).then(res => {
							if (res.code == 0) {
								this.infoDisabled = false
								this.$message.success('信息变更成功');
								this.doSearch()
							}else{
								this.$message.error(res.msg);
							}
						})
			}
			
		},
		getUserSelectInfo(query){
			// 获取基础信息
			query = query ? query : ''
			this.$api.post('/admin/users/user/getuserbydepartment',{ query: query}).then(res => {
					if (res.code === 0) {
						this.options.contact_options = res.data
						this.infoDisabled = true
					} 
			})
		},
		handleContactsOpen(type,id,uids){
			this.multipleType = type
			this.oneInfoData.id = id
			this.oneInfoData.uid = uids
			if(type == 'contact'){
				this.multiple=true
			}else{
				this.multiple=false
			}
			this.getUserSelectInfo()
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		exportData () {
			this.isDownloading = true;
			var excelSearch = JSON.parse(JSON.stringify(this.searchForm))
			excelSearch.downloadType = 'customer'
			this.$api.get('/admin/customers/export/exportcustomerexcel', excelSearch).then(res => {
				if (res.code == 0) {
						this.$alert('异步下载任务【客户列表下载】创建成功！请稍后查看下载列表', '下载提示', {
							confirmButtonText: '确定',
						});
				}else{
					this.$message({
						type: 'error',
						message: res.msg
					});
				}
				this.isDownloading = false;
				// // 将Blob转换为URL以便创建一个可下载的链接
				// const url = window.URL.createObjectURL(new Blob([res]));
				// const link = document.createElement('a');
				// link.href = url;
				// link.setAttribute('download', '客户信息.xlsx'); // 设置下载文件名
				// document.body.appendChild(link);
				// link.click(); // 触发点击下载
				// document.body.removeChild(link); // 下载后移除元素
				// window.URL.revokeObjectURL(url); // 释放URL对象
				// this.isDownloading = false
				// this.$alert('您所下载的Excel数据已完毕,请查收！', '下载提示', {
				// 	confirmButtonText: '确定',
				// });
			})
		},
		//列表查询
		handleSearch (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.tableData = []
			if (this.activeListType == 'first') {
				this.$api.get('/admin/customers/customer/getcustomerlist', param).then(res => {
					if (res.code == 0) {
						this.tableKey += 1
						this.tableData = res.data;
						this.loading = false
						this.$nextTick(() => {
							if (this.$refs.table) {
								this.$refs.table.doLayout();
							}
						});
					} else {
						this.$message.error(res.msg);
					}
				})
			} else if (this.activeListType == 'second') {
				this.$api.get('/admin/customers/customer/customerdraftlist', param).then(res => {
					if (res.code == 0) {
						this.tableKey += 1
						this.tableData = res.data;
						this.loading = false
						this.$nextTick(() => {
							if (this.$refs.table) {
								this.$refs.table.doLayout();
							}
						});
					} else {
						this.$message.error(res.msg);
					}
				})
			}

		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		clearAddForm () {
			this.addForm = {
				info: {
					customer_type: '',
					customer_name: '',
					customer_as: '',
					customer_number: '',
					customer_industry: '',
					legal_representative: '',
					registered_capital: '',
					date_of_establishment: '',
					end_type: 1,
					business_license_end: '',
					business_scope: '',
					business_license_pic: [],
					medium_department_id: '',
					business_docking_id: ''
				},
				contacts: {
					name: '',
					link_phone: '',
					email: '',
					position: '',
					contact_ids: [],
					contact_ids_txt: '',
					wechat: ''
				},
				risk: {
					is_advance: 1,
					advance_payment: '',
					period: '',
					credit_line: '0',
					average_profit_margin: '0',
					minimum_profit_margin: '0'
				},
				invoice: {
					address: '',
					phone: '',
					bank_of_deposit: '',
					bank_branch: '',
					bank_card: '',
					invoice_type: '',
					invoice_rate: '',
					refund_account: '',
					invoice_prove: [],
					fp_attachment: [],
					taxpayer_prove: []
				},
			}
			this.ContactidsData = {}
		},
		// 添加客户弹窗
		addCustomerOpen () {
			this.formType = 'add'
			this.clearAddForm()
			this.supplier_active = 0
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.addFormVisiable = true;
		},
		//获取对接人
		getContactIds () {
			this.$api.get('/admin/users/user/getusertree').then(res => {
				if (res.code === 0) {
					this.options.contact_ids_options = res.data;//对接人
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取开户行
		requestKhh () {
			this.$api.get('/admin/resources/resources/getbankname').then(res => {
				if (res.code === 0) {
					this.options.khh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取支行
		requestZh (id, changetype) {
			//changetype为clear则清空关联，keep为编辑状态下默认的值不清空
			if (changetype == 'clear') {
				this.addForm.invoice.bank_branch = '';
			}
			this.$api.get('/admin/resources/resources/getbankname', { id: id }).then(res => {
				if (res.code === 0) {
					this.options.zh_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取回款账户
		getRemittanceBanck () {
			this.$api.get('/admin/customers/customer/getremittancebanck').then(res => {
				if (res.code === 0) {
					this.options.refund_account_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//下一步
		next () {
			let keys = []
			if (this.supplier_active == 0) {
				keys = Object.keys(this.addForm.info).map(key => `info.${key}`);
			} else if (this.supplier_active == 1) {
				keys = Object.keys(this.addForm.contacts).map(key => `contacts.${key}`);
			} else if (this.supplier_active == 2) {
				keys = Object.keys(this.addForm.risk).map(key => `risk.${key}`);
			}
			const fieldsToValidate = keys; // 需要验证的字段名数组
			let allValid = [];
			fieldsToValidate.forEach(field => {
				this.$refs['addForm'].validateField(field, (err) => {
					// 如果某个字段验证失败，处理错误并决定是否继续验证其他字段
					if (err) {
						allValid.push(1)
						return
					}
				});
			});
			// 所有字段验证完成后，检查allValid的值
			if (allValid.length <= 0) {
				this.supplier_active++
			}

		},
		//上一步
		prev () {
			if (this.supplier_active-- < 1) this.supplier_active = 0;
		},
		//提交
		addCtsupplier () {
			const formData = new FormData()
			let arr = ['business_license_pic', 'invoice_prove', 'fp_attachment', 'taxpayer_prove']
			for (const keyp in this.addForm) {
				for (const key in this.addForm[keyp]) {
					if (arr.indexOf(key) != -1) {
						if (this.addForm[keyp][key] && this.addForm[keyp][key].length > 0) {
							this.addForm[keyp][key].forEach(item => {
								formData.append(key, item)
							})
						} else {
							formData.append(key, '')
						}
					} else if (key == 'contact_ids') {
						this.addForm[keyp][key].forEach((item, index) => {
							formData.append(key, item);
						})
					} else {
						formData.append(key, this.addForm[keyp][key]);
					}
				}
			}
			this.$refs['addForm'].validate((valid) => {
				if (valid) {
					//通过校验进入下一步
					if (this.formType == 'add' || this.activeListType == 'second') {
						this.$api.post('/admin/customers/customer/createcustomer', formData).then(res => {
							if (res.code === 0) {
								// 重新加载表格
								this.doSearch();
								this.supplier_active++
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					} else {
						this.$api.post('/admin/customers/customer/editcustomer', formData).then(res => {
							if (res.code === 0) {
								// 重新加载表格
								this.handleSearch('', this.tableData.page);
								this.other_tip = res.other.info ? res.other.info : '';
								this.supplier_active++
							} else {
								this.$message.error(res.msg);
							}
							this.loading = false
						})
					}
				}
			})
		},
		saveTemplate () {
			if (this.supplier_active == 0) {
				let keys = []
				keys = Object.keys(this.addForm.info).map(key => `info.${key}`);
				const fieldsToValidate = keys; // 需要验证的字段名数组
				let allValid = [];
				fieldsToValidate.forEach(field => {
					this.$refs['addForm'].validateField(field, (err) => {
						// 如果某个字段验证失败，处理错误并决定是否继续验证其他字段
						if (err) {
							allValid.push(1)
							return
						}
					});
				});
				if (allValid.length == 0) {
					if (this.formType == 'add') {
						this.saveTemplateFun()
					} else if (this.formType == 'edit') {
						this.saveTemplateEditFun()
					}
				}
			} else {
				if (this.formType == 'add') {
					this.saveTemplateFun()
				} else if (this.formType == 'edit') {
					this.saveTemplateEditFun()
				}
			}
		},
		saveTemplateFun () {
			const formData = new FormData()
			let arr = ['business_license_pic', 'invoice_prove', 'fp_attachment', 'taxpayer_prove']
			for (const keyp in this.addForm) {
				for (const key in this.addForm[keyp]) {
					if (arr.indexOf(key) != -1) {
						if (this.addForm[keyp][key].length > 0) {
							this.addForm[keyp][key].forEach(item => {
								formData.append(key, item)
							})
						} else {
							formData.append(key, '')
						}
					} else if (key == 'contact_ids') {
						this.addForm[keyp][key].forEach((item, index) => {
							formData.append(key, item);
						})
					} else {
						formData.append(key, this.addForm[keyp][key]);
					}
				}
			}
			this.loading = true
			this.$api.post('/admin/customers/customer/createcustomerdraft', formData).then(res => {
				if (res.code === 0) {
					// 重新加载表格
					this.$message({
						showClose: true,
						message: '该客户已保存成功！',
						type: 'success'
					});
					this.closeForm()
					this.doSearch()
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		saveTemplateEditFun () {
			const formData = new FormData()
			let arr = ['business_license_pic', 'invoice_prove', 'fp_attachment', 'taxpayer_prove']
			for (const keyp in this.addForm) {
				for (const key in this.addForm[keyp]) {
					if (arr.indexOf(key) != -1) {
						if (this.addForm[keyp][key].length > 0) {
							this.addForm[keyp][key].forEach(item => {
								formData.append(key, item)
							})
						} else {
							formData.append(key, '')
						}
					} else if (key == 'contact_ids') {
						this.addForm[keyp][key].forEach((item, index) => {
							formData.append(key, item);
						})
					} else {
						formData.append(key, this.addForm[keyp][key]);
					}
				}
			}
			this.loading = true
			this.$api.post('/admin/customers/customer/editcustomerdraft', formData).then(res => {
				if (res.code === 0) {
					// 重新加载表格
					this.$message({
						showClose: true,
						message: '该客户已保存成功！',
						type: 'success'
					});
					this.closeForm()
					this.doSearch()
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//点击查看大图
		viewImg (file) {
			if (!file.path) {
				//还未上传
				let url = URL.createObjectURL(file)
				if (file.name.includes('.pdf')) {
					window.open(url)
				} else {
					this.dialogImageUrl = url;
					this.dialogVisibleImg = true;
				}

			} else {
				//已上传
				if (file.name.includes('.pdf')) {
					window.open(file.path)
				} else {
					this.dialogImageUrl = file.path;
					this.dialogVisibleImg = true;
				}
			}
		},
		//上传图片
		changeRequired (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this.addForm[formobj][field] = [file.raw]
			} else {
				this.addForm[formobj][field].push(file.raw)
			}
		},
		//移除图片
		handleRemoveUpload (file, formobj, field, limitOne = true) {
			if (limitOne) {
				this.addForm[formobj][field] = []
			} else {
				this.addForm[formobj][field].forEach(function (item, index) {
					if (item.name == file.name) {
						this.$delete(this.addForm[formobj][field], index)
					}
				}.bind(this))
			}
		},
		//编辑弹窗
		handleTableEditOpen (row) {
			this.loading = true
			this.formStatus = row.status
			this.supplier_active = 0
			if (this.activeListType == 'first') {
				this.$api.get('/admin/customers/customer/getcustomer', { customer_code: row.customer_code }).then(res => {
					if (res.code == 0) {
						this.formType = 'edit'
						this.addForm.info = res.data.info
						this.addForm.contacts = res.data.contacts
						this.addForm.risk = res.data.risk
						this.addForm.invoice = res.data.invoice
						this.ContactidsData.customer_code = row.customer_code
						this.ContactidsData.contact_ids = res.data.contacts.contact_ids
						this.ContactidsData.contact_ids_department = res.data.contacts.contact_ids_department
						if (this.addForm.invoice.bank_of_deposit) {
							this.requestKhh()
							this.requestZh(this.addForm.invoice.bank_of_deposit, 'keep')
						}
						if (res.data.info.medium_department_id) {
							this.handleChangeDepartment(res.data.info.medium_department_id, "keep")
						}
						this.addFormVisiable = true;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			} else if (this.activeListType == 'second') {
				this.$api.get('/admin/customers/customer/customerdraftinfo', { id: row.id }).then(res => {
					if (res.code == 0) {
						this.formType = 'edit'
						this.addForm.info = res.data.info
						this.addForm.info.id = row.id
						this.addForm.contacts = res.data.contacts
						this.addForm.risk = res.data.risk
						this.addForm.invoice = res.data.invoice
						this.ContactidsData.customer_code = ''
						this.ContactidsData.contact_ids = res.data.contacts.contact_ids
						this.ContactidsData.contact_ids_department = res.data.contacts.contact_ids_department
						if (this.addForm.invoice.bank_of_deposit) {
							this.requestKhh()
							this.requestZh(this.addForm.invoice.bank_of_deposit, 'keep')
						}
						if (res.data.info.medium_department_id) {
							this.handleChangeDepartment(res.data.info.medium_department_id, "keep")
						}
						this.addFormVisiable = true;
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}
		},
		closeForm () {
			this.addFormVisiable = false
			this.isshow = false
			if (this.formType == 'edit') {
				this.clearAddForm()
				this.$nextTick(() => {
					this.$refs['addForm'].clearValidate();
				});
			}
			this.activeListType = 'first'
			this.handleSearch()
		},
		//删除
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该客户, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				if (this.activeListType == 'first') {
					//列表删除
					this.$api.delete('/admin/customers/customer/delcustomer', { customer_code: row.customer_code }).then(res => {
						if (res.code === 0) {
							var data = this.tableData.data;
							data.forEach(function (item, index) {
								if (item.customer_code == row.customer_code) {
									this.$delete(data, index);
								}
							}.bind(this));
							this.$message({
								showClose: true,
								message: '该客户已成功删除！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else if (this.activeListType == 'second') {
					//草稿删除
					this.$api.delete('/admin/customers/customer/delcustomerdraft', { id: row.id }).then(res => {
						if (res.code === 0) {
							var data = this.tableData.data;
							data.forEach(function (item, index) {
								if (item.id == row.id) {
									this.$delete(data, index);
								}
							}.bind(this));
							this.$message({
								showClose: true,
								message: '该客户草稿已成功删除！',
								type: 'success'
							});
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}

			}.bind(this))
		},
		//提交审批
		handleTableFlow (row) {
			this.$api.post('/admin/customers/customer/confirmsubmitcustomer', { customer_code: row.customer_code }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.customer_code == item.customer_code) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该客户已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//设置取消黑名单
		handleTableBlack (row) {
			this.$api.put('/admin/customers/customer/updatecustomer', { customer_code: row.customer_code }).then(res => {
				if (res.code === 0) {
					this.$message({
						showClose: true,
						message: '黑名单状态修改成功！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'CustomerDetail',
				query: { id: row.id, set_id: 2, type: 'detail' }
			});
		},
		//获取所有用户部门
		getUserTree () {
			this.options.usertree_options = []
			this.$api.get('/admin/users/user/getDepartmentTree').then(res => {
				if (res.code === 0) {
					this.options.usertree_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		//获取所属部门下的用户
		handleChangeDepartment (value, type) {
			if (type == "clear") {
				this.options.business_docking_options = []
				this.addForm.medium_id = ''
				this.addForm.info.business_docking_id = ''
			}
			this.$api.post('/admin/users/user/getuserbydepartment', { department_id: [value] }).then(res => {
				if (res.code === 0) {
					this.options.business_docking_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		fieldEvent (data) {
			this.checkedContactids = data
		},
		openDjr () {
			this.dialogVisibleContactids = true
		},
		openedIsshow () {
			this.isshow = true
			this.ContactidsData.contact_ids = this.addForm.contacts.contact_ids
			this.ContactidsData.contact_ids_department = this.addForm.contacts.contact_ids_department
		},
		confirmContactids () {
			if (this.checkedContactids && this.checkedContactids.length > 0) {
				const labels = this.checkedContactids.map(item => item.label);
				this.addForm.contacts.contact_ids_txt = labels.join(',');
				this.addForm.contacts.contact_ids = this.checkedContactids.map(item => item.value)
				this.dialogVisibleContactids = false
			} else {
				this.$message.error("请至少选择一个人员！");
			}
		},
		handleListtype (tab, event) {
			this.handleSearch(this.searchForm, 1)
		},
		changeAdvance () {
			if (this.addForm.risk.is_advance == 2) {
				this.addForm.risk.advance_payment = ''
			}
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			// 使用 === 进行严格相等判断
			if (from.path !== '/customerDetail') {
				try {
					vm.reset();
				} catch (error) {
				}
			}
		});
	}
}
</script>
<style scoped>
.addBox {
	padding: 50px 30px 0;
}
</style>